/* eslint-disable */
import { phoneTypes } from '@ringcentral-integration/commons/enums/phoneTypes';
export default {
  [phoneTypes.business]: 'Työpuhelin',
  [phoneTypes.extension]: 'Alanumero',
  [phoneTypes.home]: 'Kotinumero',
  [phoneTypes.mobile]: 'Matkapuhelin',
  [phoneTypes.phone]: 'Puhelin',
  [phoneTypes.unknown]: 'Tuntematon puhelintyyppi',
  [phoneTypes.company]: 'Yrityksen numero',
  [phoneTypes.direct]: 'Suora numero',
  [phoneTypes.contact]: 'Yhteystiedon puhelin',
  [phoneTypes.fax]: 'Faksi',
  [phoneTypes.other]: 'Muu',
};

// @key: @#@"[phoneTypes.business]"@#@ @source: @#@"Business Phone"@#@
// @key: @#@"[phoneTypes.extension]"@#@ @source: @#@"Extension Number"@#@
// @key: @#@"[phoneTypes.home]"@#@ @source: @#@"Home Number"@#@
// @key: @#@"[phoneTypes.mobile]"@#@ @source: @#@"Mobile Phone"@#@
// @key: @#@"[phoneTypes.phone]"@#@ @source: @#@"Phone"@#@
// @key: @#@"[phoneTypes.unknown]"@#@ @source: @#@"Unknown Phone Type"@#@
// @key: @#@"[phoneTypes.company]"@#@ @source: @#@"Company Number"@#@
// @key: @#@"[phoneTypes.direct]"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"[phoneTypes.contact]"@#@ @source: @#@"Contact Phone"@#@
// @key: @#@"[phoneTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"[phoneTypes.other]"@#@ @source: @#@"Other"@#@
